const checkChildren = ({ nodeSelected, childCount, showOrderTimes }) => {
  if (showOrderTimes && childCount) {
    childCount.forEach((child) => {
      if (child.id === nodeSelected.id) {
        showOrderTimes = false;
      }
      checkChildren({
        nodeSelected,
        childCount: child.children,
        showOrderTimes,
      });
    });
  }
  return showOrderTimes;
};

const orderTimes = ({ menu, node }) => {
  const children = menu.children;
  const showPreOrder = children.some((child) => child.id === node.id);

  let showOrderTimes = true;

  if (!showPreOrder) {
    const childNode = children.find((child) => {
      const end = child.subject.delivery_end;
      const start = child.subject.delivery_start;
      if (end && start && showOrderTimes) {
        showOrderTimes = checkChildren({
          nodeSelected: node,
          childCount: child.children,
          showOrderTimes,
        });
      }
      return !showOrderTimes;
    });

    if (childNode) {
      showOrderTimes = false;
    }
  }

  return {
    showOrderTimes,
    showPreOrder,
  };
};

export const newNodeTimeCheck = ({ menu, nodeParent, node }) => {
  if (!nodeParent) {
    return {
      showPreOrder: false,
      showOrderTimes: true,
    };
  } else if (!node.id) {
    const orderTimesInfo = orderTimes({ menu, node: nodeParent });

    return {
      showPreOrder: false,
      showOrderTimes: orderTimesInfo.showOrderTimes,
    };
  } else {
    return orderTimes({ menu, node });
  }
};

export const isAlwaysAvailable = (node) =>
  !node.subject.availability_end.length &&
  !node.subject.availability_start.length;

export const getBatchCollection = (node) => {
  const end = node.subject.delivery_end;
  const start = node.subject.delivery_start;
  return end && start;
};
